import * as C from "io-ts/Codec";
import * as Eq from "fp-ts/Eq";
import * as n from "fp-ts/number";

export const BBoxModel = C.tuple(C.number, C.number, C.number, C.number);

export type BBox = C.TypeOf<typeof BBoxModel>;

export const BBoxEq = Eq.tuple<BBox>(n.Eq, n.Eq, n.Eq, n.Eq);
